import { render, staticRenderFns } from "./AddGame.vue?vue&type=template&id=528723b6&scoped=true&"
import script from "./AddGame.vue?vue&type=script&lang=js&"
export * from "./AddGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528723b6",
  null
  
)

export default component.exports